import { Pipe, PipeTransform } from "@angular/core";
import { isNumber } from "@utils/boolean.util";

@Pipe({
  name: "montoAsegurado",
})
export class MontoAseguradoPipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (value === undefined) return "";

    if (isNumber(value)) {
      return value.toLocaleString();
    }
    return value;
  }
}
